import React, { useState } from "react";
import GroupAddIcon from "@material-ui/icons/GroupAdd";
import { Button, CircularProgress, Tooltip } from "@material-ui/core";
import config from "../../config";
import { useAuth } from "../../context/Auth";
import Modal from "../Modal";
import DepartmentSelect from "../DepartmentSelect";
import { Stack, Typography } from "@mui/material";

const AddEveryone = ({ eventId, setReload }: any) => {

  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [departmentIds, setDepartmentIds] = useState<number[]>([]);
  const { fetchWithUser } = useAuth()

  const addEveryone = () => {
    setLoading(true);
    const url = `${config.apiUrl}/HolidayGift/AddEmployeeGroupToGiftEvent?groupTypeID=${1}&eventID=${eventId}`;
    fetchWithUser(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(departmentIds),
    }).then(_ => {
      setReload(true);
      setLoading(false);
      setOpen(false);
    });
  };

  return (
    <>
      <Tooltip title="Adds all active employees" placement="top">
        <Button
          variant="contained"
          disableElevation
          size="medium"
          color="primary"
          onClick={() => setOpen(true)}
          disabled={loading}
        >
          <GroupAddIcon />
          Add Everyone
          {loading && <CircularProgress
            size={24}
          />}
        </Button>
      </Tooltip>
      <Modal
        open={open}
        title="AddEveryone"
        onClose={() => setOpen(false)}
        onSave={addEveryone}
        saveText="Add Everyone"
        disabled={loading}
      >
        <Stack>
          <Typography variant="caption" color="primary">Select departments to exclude from this gift:</Typography>
          <DepartmentSelect multiple={true} onChange={setDepartmentIds} defaultValue={departmentIds} />
          <Typography variant="caption" color="warning" sx={{ mt: 3 }}>Are you sure you want to add everyone (except members of the excluded departments)?</Typography>
          <Typography variant="caption" color="error">This action cannot be undone.</Typography>
        </Stack>
      </Modal>
    </>
  );
};

export default AddEveryone;
